const BookingChangeCause = {
    CUSTOMER_REQUEST: "customer-request",
    OTHER: "other",
    STOCK: "stock",
    WEATHER: "weather",
};

export default BookingChangeCause;
